namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmSpisovna extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmSpisovnaReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmSpisovnaObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmSpisovnaObj());
            this.detailObj.createBase({
                contentName: "detailAdmSpisovna",
                contentCaption: "jres:33000336",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getSeznamAdmSpisovnaKategorieDokumentuTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getSeznamAdmSpisovnaKategorieDokumentuGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            builder.withComponent<this>("DetailAdmSpisovna", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmSpisovnaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmSpisovnaReadDto> {
        private filterInterniSubjektyIco: boolean;
        private napovedaTags: DictionaryObject[];

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["ixs_spi"]
        }

        setSxsDetail(): string {
            return `${this.data.ixs_spi}`;
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmSpisovnaSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            (this.cnt.isl.AdmSpisovna.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSpisovna", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmSpisovna.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.data.nazev}`;
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" },
                { favorite: true, type: "static", caption: "jres:33000138", icon: "fa-link", children: [{ action: this.cnt.actions.actSeznamAdmFunkcniMistoSpisovna }] }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actHelpFormat: {
                    caption: "jres:33000337", //RC 33000337 : Dostupné formáty
                    icon: "gi-question_bold",
                    run: (ev, ctx) => {
                        this.setFormatToField(ctx);
                    }
                },
                actSeznamAdmFunkcniMistoSpisovna: {
                    icon: "fa-link",
                    caption: "jres:33000357", //RC 33000357 : Přiřazené funkce
                    run: (ev, ctx) => {
                        Gordic.Adm.WebControls.AdmSpisovna.openSeznamAdmFunkcniMistoSpisovna(this.data);
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actSeznamAdmFunkcniMistoSpisovna?.enabled(!editMode);
        }

        createForm() {
            this.MakeField("ixs_spi", { flag: this.createFlagNemenne() });
            this.MakeField("nazev");
            this.MakeField("zkratka");
            this.MakeField("poznamka");
            this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                model: "model.ixs_su=value.ixs_su",
                serverFilters: {
                    // TODO: kontrola na ICO (zatím povolené všechny)
                    GpcIcoOrSharedIco: this.filterInterniSubjektyIco
                }
            });
            this.MakeSelectField("typ_spi", Gordic.Prefabs.Select.spictsp(), { model: "model.typ_spi=value.typ_spi" });
            this.MakeField("format_zn_zup", {
                buttons: [
                    {
                        type: "action",
                        actionContext: { field: "format_zn_zup" },
                        action: this.cnt.actions.actHelpFormat
                    }
                ]
            });
            this.MakeField("format_zn_vyl", {
                buttons: [
                    {
                        type: "action",
                        actionContext: { field: "format_zn_vyl" },
                        action: this.cnt.actions.actHelpFormat
                    }
                ]
            });
            this.MakeSelectField("ixs_isu", Gordic.Prefabs.Select.admInterniSubjekt(), {
                dropdown: false,
                model: "model.ixs_isu=value.ixs_esu",
                serverFilters: {
                    // TODO: kontrola na ICO (zatím povolené všechny)
                    GpcIcoOrSharedIco: this.filterInterniSubjektyIco
                },
                change: (ev, obj) => {
                    if (obj.value) {
                        this.cnt.findFields("ixs_isu_adresa").gfield("setValue", "{0}\n{1}\n{2}\n{3}".format(obj.value["st3"], obj.value["st4"], obj.value["st5"], obj.value["st6"]))
                    } else
                        this.cnt.findFields("ixs_isu_adresa").gfield("setValue", "")
                }
            })
            this.MakeRow("ixs_isu_adresa").addField("gstringbox", {
                rows: 4,
                name: "ixs_isu_adresa",
                disabled: true
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private setFormatToField(ctx: any) {
            var fieldName = ctx.field;
            this.cnt.dialogs.showModalWindow([Gordic.Adm.WebControls.HelperTagsAdmSpisovna, { napovedaTags: this.napovedaTags }], null, {
                width: 600,
                height: 400
            }).on("close", (obj) => {
                var result = obj as any;
                if (result.returnValue) {
                    var currentValue = this.cnt.findFields(fieldName).gfield("getValue");
                    if (result.returnValue["addTags"] == true)
                        currentValue += result.returnValue["tags"];
                    else
                        currentValue = result.returnValue["tags"];
                    this.cnt.findFields(fieldName).gfield("setValue", currentValue);
                }
            })
        }

        getSeznamAdmSpisovnaKategorieDokumentuTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab_spisovna_kat_dokumentu",
                    title: "jres:33000840",
                    opened: true,
                    locked: true,
                    group: { id: "_tab_spisovna_kat_dokumentu" }
                },
                contentParams: {
                    className: "Gordic.Adm.WebControls.SeznamAdmSpisovnaKategorieDokumentu",
                    serverParams: {
                        ID: "SeznamAdmSpisovnaKategorieDokumentu",
                        ixs_spi: this.data.ixs_spi,
                        tabOpen: true
                    }
                }
            }
        }

        getSeznamAdmSpisovnaKategorieDokumentuGroup(): IGTabGroupOptions {
            return { id: "_tab_spisovna_kat_dokumentu", caption: "jres:33000840" }
        }
    }
}